import './IconButton.css'
import React from 'react'
import classNames from 'classnames'
import { Tooltip, TooltipProps } from 'antd'

type Props = {
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  type?: "submit" | "reset" | "button";
  className?: string;
  children?: React.ReactNode;
  tooltip?: string | TooltipProps;
  disabled?: boolean;
}

export default function IconButton({ disabled, onClick, type, className, children, tooltip }: Props) {
  const tooltipProps = typeof tooltip === 'object' ? tooltip : { title: tooltip };

  return (
    <Tooltip {...tooltipProps}>
      <button
        onClick={onClick}
        type={type}
        disabled={disabled}
        className={
          classNames([
            'icon-button',
            className
          ])
        }>{children}</button>
    </Tooltip>
  )
}
